<template>
  <ul class="paging" v-if="page.curPage">
    <li @click="changePage(page.curPage-1)">
      <a href="javascript:;" :class="{'disabled':page.curPage==1}">
        <img src="../images/personal_center/collection-left.png" alt="" />
      </a>
    </li>
    <li name="page-body" v-for="item in initPage" :class="{'active':page.curPage==item,'apostrophe':item=='...'}" @click="changePage(item)">
      <a href="javascript:;">{{item}}</a>
    </li>
    <li @click="changePage(page.curPage+1)">
      <a href="javascript:;" :class="{'disabled':page.curPage==page.totalPage}">
        <img src="../images/personal_center/collection-right.png" alt="" />
      </a>
    </li>
  </ul>
</template>

<script type="text/javascript">
  export default {
    props: {
      page: {
        type: Object,
        default: {
          curPage: 1,    // 当前页码
          totalPage: 1   // 总页数
        }
      }
    },
    data() {
      return {
        pages: []
      }
    },
    computed: {
      initPage() {
        this.turnPage();
        return this.pages;
      }
    },
    methods: {
      changePage(curPage) {
        if (curPage > this.page.totalPage || curPage == 0 || curPage == "...") {
          return ;
        }
        this.page.curPage = curPage;
        this.turnPage();
      },
      turnPage() {
        let self = this;
        self.pages = [];
        let totalPage = this.page.totalPage;
        let curPage = this.page.curPage;
        if (totalPage<=9) {  // 小于等于9页 全部显示
          for (let i = 0; i < totalPage; i++) {
            self.pages.push(i+1)
          }
        }else if (totalPage > 9) {   // 总页数大于等于10页
          if (curPage < 7) {  // 当前页小于7 加载前七页 显示最后两页
            for (let i = 0; i < 7; i++) {
              self.pages.push(i+1);
            }
            if (curPage <= totalPage-2) {
              self.pages.push("...");
              self.pages.push(totalPage-1);
              self.pages.push(totalPage);
            }
          }else if (curPage > totalPage - 6) {  // 当前页处于后七页
            for (let i = 0; i < 2; i++) {   // 1 2页始终显示
              self.pages.push(i+1);
            }
            self.pages.push("...");
            for (let i = totalPage-6; i <= totalPage; i++) {
              self.pages.push(i);
            }
          }else if (curPage >= 7){ // 当前页大于7页
            for (let i = 0; i < 2; i++) {   // 1 2页始终显示
              self.pages.push(i+1);
            }
            self.pages.push("...");
            for (let i = curPage - 2; i <= curPage + 2; i++){
              self.pages.push(i);
            }
            self.pages.push("...");
            self.pages.push(totalPage-1);
            self.pages.push(totalPage);
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.turnPage();
      })
    }
  }
</script>

<style media="screen" lang="scss">
  .paging{
    margin-bottom: 28px;
    text-align: right;
    color: #878996;
    li{
      display: inline-block;
      a{
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 34px;
        text-align: center;
        background: #fff;
        border: 1px solid #dbdbdb;
        border-radius: 3px;
        color: #878996;
        cursor: pointer;
        user-select: none;
        -ms-user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        &:hover,&.disabled{
          background: #f4f4f4;
        }
      }
      &.active{
        a{
          color: #fff;
          background: #20a0ff;
          border-color: #20a0ff;
        }
      }
      &.apostrophe{
        a{
          border: none;
          width: auto;
          padding: 0 5px;
          background: transparent;
          cursor: default;
        }
      }
    }
    li+li{
      margin: 0 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// page.vue?27aaca10